'use strict';
import { extendedCRUDMethods } from './extendedCRUDMethods';

export default function DailyReportResource($resource) {
  'ngInject';
  return $resource(
    '/api/dailyReports/:dataType/:id/:action/:actionId/:other',
    { id: '@id', action: '@action', dataType: 'shops' },
    Object.assign(
      {
        dates: {
          method: 'GET',
          params: { id: '@_id', action: 'dates' },
          isArray: true
        },
        all: { method: 'GET', params: { dataType: '' }, isArray: true },
        months: {
          method: 'GET',
          params: { dataType: 'months' },
          isArray: true
        },
        getReportBefore: {
          method: 'GET',
          params: {
            dataType: 'shops',
            id: '@id',
            action: 'reports',
            actionId: '@actionId',
            other: 'before'
          }
        },
        deleteNotes: {
          method: 'DELETE',
          params: {
            dataType: '@id',
            action: 'notes'
          }
        },
        toggleWithdrawn: {
          method: 'GET',
          params: {
            dataType: '@id',
            action: 'withdrawn'
          }
        }
      },
      extendedCRUDMethods
    )
  );
}



// WEBPACK FOOTER //
// ./client/components/resources/dailyReport.resource.ts